module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/client-transactions/add-deposit/add-deposit.component.css
// module id = ./src/app/client-transactions/add-deposit/add-deposit.component.css
// module chunks = main